module.exports = __webpack_public_path__ + "static/turtle-creek-house46-69c91a8431c20032cccb21345e8520e0.jpg";